import { getGtmId, isGtmEnabled } from './env';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

const GTM_SCRIPT_ID = 'gtm-script';
const GTM_NOSCRIPT_ID = 'gtm-noscript';

const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer ?? [];
};

export const loadGTM = (): void => {
  if (!isGtmEnabled()) {
    return;
  }

  const gtmId = getGtmId();
  if (!gtmId) {
    return;
  }

  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  ensureDataLayer();
  window.dataLayer?.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  if (!document.getElementById(GTM_NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript');
    noscript.id = GTM_NOSCRIPT_ID;
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(noscript);
  }
};

export const trackPageView = (path: string, title?: string): void => {
  if (!isGtmEnabled() || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event: 'page_view',
    page_path: path,
    page_title: title,
  });
};

export const trackEvent = (eventName: string, params: Record<string, unknown> = {}): void => {
  if (!isGtmEnabled() || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};
